import { render } from "./JointGrid.vue?vue&type=template&id=b8294040"
import script from "./JointGrid.vue?vue&type=script&lang=js"
export * from "./JointGrid.vue?vue&type=script&lang=js"

import "./JointGrid.vue?vue&type=style&index=0&id=b8294040&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__